import { render } from "./App.vue?vue&type=template&id=32298f34"
const script = {}

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__